// Partner booths: media / NGOs that work for democracy and share voter tools.
// Content is data (assets/partners.json); logos live in assets/partners/.

export interface PartnerResource {
  title: string;
  url: string;
}

export interface Partner {
  slug: string; // matches PARTNER_SLUGS in scene/walls.ts
  name: string;
  url?: string; // the organisation's site
  logo: string; // e.g. "/assets/partners/el-espectador.png"
  resources: PartnerResource[];
}

export interface Partners {
  partners: Partner[];
}

const EMPTY: Partners = { partners: [] };

export async function loadPartners(): Promise<Partners> {
  try {
    const res = await fetch("/assets/partners.json");
    if (!res.ok) return EMPTY;
    return (await res.json()) as Partners;
  } catch {
    return EMPTY; // booths just render their fallback / nothing
  }
}
